export default __webpack_public_path__ + "static/media/no-img.f7a3f7b8.png";